module.exports = __webpack_public_path__ + "static/img/5.6ad30f39.png";